export default __webpack_public_path__ + "static/Girl_Geek_X_ELEVATE_2024-05d0c7c027582eba7af14e7148bf5391.jpeg";